const e = {
  beaconTagName: "beacon-popover",
  beaconNestedComponents: ["beacon-icon-button"],
  iconButtonElementName: "beacon-icon-button",
  arrowSpaceMargin: "24px",
  arrowSizeInline: "12px",
  targetQuerySelector: ".popover-target",
  popoverWrapperQuerySelector: ".beacon-popover-wrapper",
  DATA_METRICS_LOCATION_POPOVER: "PU",
  DATA_METRICS_LOCATION_BEACON_ICON_POPOVER: "BDY"
};
export {
  e as C
};
